import { Component, Input } from '@angular/core';

import { MaterialModel } from '@evorait/pace-core';

@Component({
    selector: 'pace-confirmation-summary-material',
    templateUrl: './confirmation-summary-material.component.html',
    styleUrls: ['./confirmation-summary-material.component.scss'],
    standalone: false,
})
export class ConfirmationSummaryMaterialComponent {
    @Input()
    public materials: MaterialModel[];
}
